import React, { memo, useCallback, useMemo } from "react";

const ConfirmationCheckbox = memo(
  ({ checked, onChange, disabled, userName }) => {
    const handleChange = useCallback(
      (e) => {
        onChange(e.target.checked);
      },
      [onChange]
    );

    const checkboxClassName = useMemo(() => {
      return `w-5 h-5 ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`;
    }, [disabled]);

    const labelClassName = useMemo(() => {
      return `select-none ${
        disabled ? "opacity-50 cursor-not-allowed" : "mb-0 cursor-pointer"
      }`;
    }, [disabled]);

    return (
      <div className="flex gap-2 items-center my-4">
        <input
          type="checkbox"
          id="confirm-delete"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={checkboxClassName}
        />
        <label htmlFor="confirm-delete" className={labelClassName}>
          Je confirme la suppression de {userName}
        </label>
      </div>
    );
  }
);

export default ConfirmationCheckbox;
